<script setup lang="ts">
    import type { InputGroupButtonProps } from '.';
    import { cn } from '../utils';
    import { Button } from '../Button';
    import { inputGroupButtonVariants } from '.';

    const props = withDefaults(defineProps<InputGroupButtonProps>(), {
        size: 'xs',
        variant: 'tertiary',
    });
</script>

<template>
    <Button
        :data-size="props.size"
        :variant="props.variant"
        :class="cn(inputGroupButtonVariants({ size: props.size }), props.class)"
    >
        <slot />
    </Button>
</template>
